import React, { useEffect, useState } from 'react';
import { Page } from '../components';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const ContactPage = () => {
  const { i18n } = useTranslation();

  const [content, setContent] = useState('');

  useEffect(() => {
    const fetchContent = async () => {
      const result = await axios.get(`/manuals/${i18n.language}/contact.html`);
      setContent(result.data);
    };
    fetchContent();
  }, [i18n.language]);
  return (
    <Page>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </Page>
  );
};

export default ContactPage;
